export default {
  labels: {
    gmsIq: "GMS IQ",
    iqCrm: "SID",
    name: "Name",
    organisation_name: "Organisation Name",
    organization_name: "Organisation Name",
    add_organization: "Add Organisation",
    update_organization: "Update Organisation",
    edit_organization: "Edit Organisation",
    organizations: "Organisations",
    serial_no: "Sno",
    type: "Type",
    subtype: "Subtype",
    profile: "Profile",
    login: "Login",
    email: "Email",
    user_profile: "User Profile",
    last_login: "Last 3 Login Details",
    edit_profile: "Edit Profile",
    login_button: "Login",
    getOtp: "Recover Password",
    total: "Total",
    password: "Password",
    forget_password: "Forgot Password?",
    heading_forget: "Forgot Password",
    backto_login: "Back To Login",
    back: "Back",
    backto_forgotpassword: "Back To Forgot Password",
    submit: "Submit",
    reset_password: "Reset Password",
    new_password: "New Password",
    password_recovery: "Recovery Password",
    already_have_recovery_password: "Already have recovery password?",
    confirm_password: "Confirm Password",
    reset_pass_button: "Reset Password",
    old_password: "Current Password",
    change_password: "Change Password",
    logout: "Logout",
    import: "Import",
    csv: "CSV",
    import_csv: "Import CSV",
    sample_import_csv: "Sample Import CSV",
    download_sample_csv: "Download Sample CSV",
    choose_file: "Choose File ",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    save_password: "Save Password",
    save_profile: "Save Profile",
    add_user: "Add User",
    add_client: "Add Client",
    edit_user: "Edit User",
    create_user: "Create User",
    update_user: "Update User",
    export: "Export",
    admin: "Admin",
    client: "Client",
    consultant: "Consultant",
    admins: "Admins",
    clients: "Clients",
    consultants: "Consultants",
    clear: "Clear",
    search: "Search",
    block_unblock: "Block/Unblock",
    only_admin: "Only Admin",
    status: "Status",
    update_status: "Update Status",
    review_report: "Review Report",
    report: "Report",
    user_detail: "User Details",
    add_role: "Add Role",
    edit_role: "Update Role",
    adduser_role: "Add User Role",
    edituser_role: "Edit User Role",
    user_role_detail: "User Role Details",
    role_name: "Role Name",
    role_description: "Description",
    role_management: "Role Management",
    roles: "Roles",
    user_role: "User Role",
    user_roles: "User Roles",
    leads: "Leads",
    add_lead: "Add Lead",
    edit_lead: "Edit Lead",
    update_lead: "Update Lead",
    convert_lead: "Convert lead to Client",
    lead_detail: "Lead Details",
    contact_detail: "Contact Details",
    vessel_detail: "Vessel Details",
    permissions: "Permissions",
    yes: "Yes",
    no: "No",
    all: "All",
    view: "View",
    add: "Add",
    modify: "Modify",
    delete: "Delete",
    edit: "Edit",
    block: "Block",
    unblock: "Unblock",
    confirmation: "Confirmation",
    other: "Other",
    remarks: "Remarks/Comments",
    port_detail: "Port Details",
    agent_detail: "Agents Details",
    service_requirement: "Service Requirements",
    imo_number: "IMO Number",
    date_of_attendence: "Date of attendence",
    contact_name: "Contact Name",
    phone: "Phone",
    owner: "Owner",
    manager: "Manager",
    office: "Office",
    fleet: "Fleet",
    new: "New",
    in_progress: "In Progress",
    approved: "Approved",
    rejected: "Rejected",
    won: "Won",
    role: "Role",
    role_id: "Role Id",
    cancel: "Cancel",
    convert: "Convert",
    action: "Action",
    actions: "Actions",
    parent: "Parent Name",
    children: "Children",
    countries: "Countries",
    add_country: "Add Country",
    edit_country: "Edit Country",
    country_name: "Country Name",
    iso_code: "ISO Code",
    update_country: "Update Country",
    vessel_types: "Vessel Types",
    add_vessel_type: "Add Vessel Type",
    edit_vessel_type: "Edit Vessel Type",
    parent_vessel_type: "Parent Vessel Type",
    no_parent: "No Parent",
    update_vessel_type: "Update Vessel Type",
    others: "Others",
    managers: "Managers",
    offices: "Offices",
    fleets: "Fleets",
    user: "User",
    ports: "Ports",
    add_port: "Add port",
    country: "Country",
    edit_port: "Edit port",
    port_name: "Port name",
    update_port: "Update port",
    view_client: "View Client",
    add_vessel: "Add Vessel",
    edit_vessel: "Edit Vessel",
    wet: "Wet",
    dry: "Dry",
    passenger: "Passenger",
    offshore: "Offshore",
    vessel_status: "Vessel Status",
    update_vessel: "Update Vessel",
    flag: "Flag",
    port: "Port",
    active: "Active",
    deactive: "Deactive",
    vessel: "Vessel",
    vessels: "Vessels",
    high: "High",
    medium: "Medium",
    low: "Low",
    questionnaire: "Questionnaire",
    question_name: "Question Name",
    questions: "Questions",
    add_question: "Add Question",
    edit_question: "Edit Question",
    section: "Section",
    sections: "Sections",
    sub_section: "Sub Section",
    importance: "Importance",
    owners: "Owners",
    guidance_box: "Guidance Box",
    specific_to_owners: "Specific to Owners",
    specific_to_type: "Specific to Type",
    specific_to_subtype: "Specific to Subtype",
    guidance_images: "Guidance Images",
    browse_images: "Browse Images",
    images: "Images",
    add_section_subsection: "Add Section",
    edit_section_subsection: "Edit Section Subsection",
    update_section_subsection: "Update Section Subsection",
    service_name: "Service Name",
    add_service: "Add Service",
    edit_service: "Edit Service",
    update_service: "Update Service",
    designation_name: "Designation Name",
    add_designation: "Add Designation",
    edit_designation: "Edit Designation",
    update_designation: "Update Designation",
    riskfactor_name: "Risk Factor Name",
    add_riskfactor: "Add Risk Factor",
    edit_riskfactor: "Edit Risk Factor",
    update_riskfactor: "Update Risk Factor",
    parent_section: "Parent Section",
    question: "Question",
    number: "Number",
    designations: "Designations",
    services: "Services",
    ans: "Answer",
    specific_to_service: "Specific to Services",
    flags: "Flags",
    specific_to_flag: "Specific to Flags",
    specific_to_designation: "Specific to Designations",
    date: "Date",
    date_placeholder: "Please add date in DD/MM/YYYY format",
    active_deactive: "Activation-Deactivation",
    active_from: "Active From",
    active_to: "Active To",
    regulation_reference: "Regulation Reference",
    update_question: "Update Question",
    create_question: "Create Question",
    questionnaire_details: "Questionnaire Details",
    section_reference_number: "Section Reference Number",
    question_number: "Question Number",
    hazard_name: "Hazard Name",
    add_hazard: "Add Hazard",
    edit_hazard: "Edit Hazard",
    update_hazard: "Update Hazard",
    hazards: "Hazards",
    edit_topevent: "Edit Top event",
    add_topevent: "Add Top event",
    update_topevent: "Update Topevent",
    topevent_name: "Top event Name",
    topevents: "Top events",
    preventative_barriers: "Preventative Barriers",
    add_preventative_barrier: "Add Preventative Barrier",
    edit_preventative_barrier: "Edit Preventative Barrier",
    update_preventative_barrier: "Update Preventative Barrier",
    preventative_barrier_name: "Preventative Barrier Name",
    threats: "Threats",
    threat_name: "Threat Name",
    add_threat: "Add Threat",
    edit_threat: "Edit Threat",
    update_threat: "Update Threat",
    mitigating_barriers: "Mitigating Barriers",
    add_mitigating_barrier: "Add Mitigating Barrier",
    edit_mitigating_barrier: "Edit Mitigating Barrier",
    update_mitigating_barrier: "Update Mitigating Barrier",
    mitigating_barrier_name: "Mitigating Barrier Name",
    consequences: "Consequences",
    consequence_name: "Consequence Name",
    add_consequence: "Add Consequence",
    edit_consequence: "Edit Consequence",
    update_consequence: "Update Consequence",
    escalation_factor: "Escalation Factors",
    escalation_factor_name: "Escalation Factor Name",
    add_escalation_factor: "Add Escalation Factor",
    edit_escalation_factor: "Edit Escalation Factor",
    update_escalation_factor: "Update Escalation Factor",
    escalation_factor_barrier: "Escalation Factor Barriers",
    escalation_factor_barrier_name: "Escalation Factor Barrier Name",
    add_escalation_barrier_factor: "Add Escalation Factor Barrier",
    edit_escalation_barrier_factor: "Edit Escalation Factor Barrier",
    update_escalation_barrier_factor: "Update Escalation Factor Barrier",
    show: "Show",
    filter: "Filter",
    print_questions: "Print Questions",
    print_questions_with_guidance: "Print Questions with Guidance",
    ip_address: "IP Address",
    login_at: "Login At",
    logout_at: "Logout At",
    user_agent: "User Agent",
    model: "Model",
    id: "Id",
    go: "Go",
    activities: "Activities",
    description: "Description",
    changes: "Changes",
    causer: "Causer",
    time: "Time",
    history: "History",
    section_number: "Section Number",
    guidances: "Guidances",
    subtypes: "Subtypes",
    other_fields: "Other Fields",
    project_name: "Project Name",
    reviewer: "Reviewer",
    projects: "Projects",
    add_project: "Add Project",
    edit_project: "Edit Project",
    save_data: "Save data",
    work_instructions: "Work Instructions",
    travel_requirements: "Travel Requirements",
    save_as_draft: "Save as Draft",
    save_as_confirm: "Save as Confirm",
    update_project: "Update Project",
    processing_status: "Processing Status",
    code: "Code",
    defect_code: "Defect code",
    project_details: "Project Details",
    consultant_details: "Consultant Details",
    reprocess: "Re-process",
    work_instruction_attachment: "Work Instruction Attachment",
    inspection: "Inspection",
    write_answer: "Write Answer...",
    answer: "Answer",
    audio_file: "Audio Attachment",
    save_answer: "Save Answer",
    save_template: "Save Template",
    templates: "Templates",
    in_review_by_admin: "In Review by Admin",
    view_report: "View",
    sent_to_client: "Send to client",
    closed: "Closed",
    withdraw: "Withdraw",
    in_progress_by_consultant: "In Progress by Consultant",
    completed_by_consultant: "Completed by Consultant",
    in_review_by_consultant: "In Review by Consultant",
    project_status: "Project Status",
    my_status: "My Status",
    project_view: "Project View",
    questionnaire_view: "Questionnaire View",
    defects: "Defects",
    qualification_officers: "Qualification Officers",
    privilege: "Qualification Officers",
    update_defect: "Update Defect",
    update_officer: "Update Officer",
    add_defect: "Add Defect",
    add_officer: "Add Officer",
    edit_defect: "Edit Defect",
    edit_officer: "Edit Officer",
    edit_privilege: "Edit Executive Summary Template",
    defect_name: "Defect Name",
    review: "Review",
    defect: "Defect",
    select_consultant_service: "Select Consultant and Service",
    service: "Service",
    answer_images: "Answer Images",
    raise_question: "Raise Question",
    type_message: "Type a message",
    query: "Query",
    mark_as_resolved: "Mark Query as Resolved",
    raise_query: "Raise Query",
    query_answered: "Query Answered",
    chat: "Chat",
    confirm: "Confirm",
    designation: "Designation",
    query_status: "Query Status",
    sent_for_review: "Send for review",
    flag_guidance: "Flag Guidance",
    guidance_text: "Guidance Text",
    guidance: "Guidance",
    vessel_type_guidance_text: "Vessel types Guidance Text",
    mark_all_read: "Mark all as read",
    previewing_attachment: "Previewing Attachment",
    preview_attachment: "Preview Attachment",
    notifications: "Notifications",
    refresh: "Refresh",
    query_by_reviewer: "Query by reviewer",
    raising_query: "Raising a query",
    type_your_query: "Type your query",
    vessel_type_guidance: "Vessel Type Guidance",
    save_all_answer: "Save all answer",
    go_to_question_page: "Go to question page",
    previous_login_at: "Previous login",
    showing: "Showing",
    add_image_description: "Add image and description",
    add_new_image: "Add new image",
    remove_image: "Remove Image",
    vessel_type: "Vessel Type",
    start_date: "Start Date",
    latest_projects: "Latest Projects",
    uploaded_by: "Uploaded By",
    basic_details: "Basic Details",
    contact_details: "Consultant Details",
    document_details: "Documents",
    document: "Documents",
    date_of_birth: "Date of Birth",
    place_of_birth: "Place of Birth",
    nationality: "Nationality",
    rank: "Rank",
    date_of_joining: "Date of Joining",
    personal_details: "Personal Details",
    current_status: "Current Status",
    contact_information: "Contact Information",
    kin_details: "Kin Details",
    work_number: "Work Mobile Number",
    home_number: "Home Telephone Number",
    alternate_number: "Alternate Mobile Number",
    home_email: "Home Email Address",
    work_email: "Work Email Address",
    kin_contact_name: "Contact Name",
    kin_mobile_number: "Mobile Number",
    kin_alternate_number: "Alternate Number",
    kin_email_address: "Email Address",
    add_document: "Add Document",
    update_document: "Update Document",
    edit_document: "Edit Document",
    street1: "Street 1",
    street2: "Street 2",
    city: "City",
    postal_code: "Postal Code",
    address: "Address",
    issuing_authority: "Issuing Authority",
    issue_date: "Issue Date",
    issuing_country: "Issuing Country",
    expiry_date: "Expiry Date",
    document_url: "Documents",
    document_type: "Document Type",
    passport: "Passport Details",
    seamen_book: "Seamen book",
    visa: "Visa",
    other_documents: "Other Documents",
    select_documents: "Select Documents",
    select_type: "Please select type",
    select_country: "Please select country",
    issued_passport_no: "Issued to passport Number",
    consultant_profile: "Consultant Profile",
    select_docs: "Select Docs",
    zip: "Zip",
    download_document: "View attachment",
    is_active: "Is Active",
    details: "Document Details",
    demo: "Demo",
    app_download: "Download App",
    select_app: "Select App",
    linux: "Linux",
    windows: "Windows",
    officer_name: "Officer Name",
    officer_sequence: "Display Order",
    general_images: "General Images",
    qualification_of_officers: "Qualification of Officers",
    general_information: "General Information",
    executive_summary: "Executive Summary",
    executive_summary_template: "Executive Summary Template",
    add_executive_summary_template: "Add Executive Summary Template",
    editor: "Editor",
    add_qualification_officer: "Add Qualification Officer Role",
    is_corrected: "Corrected",
    select_service: "Please select service",
    download: "Download",
    vessel_assessment: "Vessel Assessment",
    miscellaneous: "Miscellaneous",
    read_more: "Read More",
    read_less: "Read Less",
    next: "Next",
    folder: "Folder",
    folders: "Folders",
    folder_name: "Folder Name",
    add_folder: "Add Folder",
    edit_folder: "Edit Folder",
    update_folder: "Update Folder",
    sub_folder: "Sub-Folder",
    sub_folders: "Sub-Folders",
    sub_folder_name: "Sub Folder Name",
    add_section: "Add Section",
    update_section: "Update Section",
    edit_section: "Edit Section",
    update_sub_folder: "Update Sub Folder",
    inspection_image: "Inspection Image",
    ship_image: "Ship Image",
    ga_plan_image: "GA Plan Image",
    no_of_folders: "No.of Folders",
    vessel_sub_type: "Vessel Sub Type",
    change_request: "Sent back to Admin",
    section_count: "No.of Section Count",
    folders_by_vessel_type: "Folders by Vessel Type",
    section_name: "Section Name",
    iqcrm: "SalusTech Integrated Database",
    location: "Location",
    add_report: "Add Report",
    share: "Share",
    draft: "Draft",
    compare: "Compare",
    pro_name: "PRO. Name",
    power_bi: "Power BI",
    add_report_url: "Add Report URL",
    report_url: "Power BI URL",
    dial_code: "Dial Code",
    explore_sid: "Explore SID",
    success: "Success",
  },
  strings: {
    login_account: "Welcome! Please login to your account.",
    forgot_account:
      "Please enter your email address and we will send you instructions on how to reset your password",
    change_pass_account:
      "Change your password to new password. Will be effective from next time you login",
    reset_pass_account:
      "Please enter recovery password sent to you on your email",
    change_profile_account:
      "Your profile information. You can update information if you want to.",
    logout_confirm: "Are you sure you want to logout?",
    delete_confirm: "Are you sure you want to Delete?",
    report_confirm: "Are you sure you want to View Report?",
    organization_deleted: "Organisation deleted successfully",
    delete_lead_confirm:
      "Deleting this client will change the status of the corresponding lead from Won to In Progress, are you sure?",
    delete_confirm_with_subtype:
      "Are you sure you want to Delete (with vessel subtypes)?",
    block_confirm: "Are you sure you want to block the user?",
    unblock_confirm: "Are you sure you want to unblock the user?",
    reset_pass_confirm: "Are you sure you want to reset password?",
    write_something: "Write Something.....",
    add_remarks: "Add remarks...",
    write_port_details: "Write about port details...",
    write_agents_details: "Write about agents details...",
    write_service_requirements: "Write about service requirements...",
    update_status: "Please select any one to update the status",
    review_report: "Please select any one to view report",
    active_confirm: "Are you sure you want to active the vessel?",
    deactive_confirm: "Are you sure you want to deactive the vessel?",
    delete_confirm_with_subsection:
      "Are you sure you want to Delete (with subsection)?",
    validation_image_error: "Please select only images",
    reprocecss_confirm: "Are you sure you want to Re-process the project?",
    add_new_comment: "Add a new comment",
    select_client_for_vessel: "Search and select vessel",
    place_of_birth: "Enter place of birth",
    select_nationality: "Select nationality",
    enter_name: "Enter name",
    enter_street1: "Enter street1",
    enter_street2: "Enter street2",
    enter_city: "Enter city name",
    select_country: "Select country ",
    enter_postal_code: "Enter postal code",
    enter_rank: "Enter rank",
    enter_contact_name: "Enter contact name",
    enter_email: "Enter email address",
    enter_mobile_number: "Enter mobile number",
    enter_alternate_mobile_number: "Enter mobile number",
    enter_work_number: "Enter Work Mobile Number",
    enter_home_number: "Enter Home Telephone Number",
    enter_alternate_number: "Enter Alternate Mobile Number",
    enter_home_email: "Enter Home Email Address",
    zip_download: "Please select documents to download it.",
    select_app: "Please Select App",
    incomplete_vessel_details:
      "Selected Vessel detail is incomplete. Please edit or SKIP for now",
    add_vessel: "Add vessel",
  },
  validations: {
    enter_email: "Please enter email",
    enter_valid_email: "Please enter valid email",
    enter_password: "Please enter password",
    enter_recovery_password: "Please enter recovery password",
    enter_old_password: "Current password is not correct",
    enter_new_password: "Please enter new password",
    enter_confirm_password: "Please enter confirm password",
    password_validation: "Password should be minimum 6 characters",
    confirm_password_validation:
      "Your password and confirmation password do not match.",
    name_limit: "You can only enter upto 255 charactrs",
    role_validation: "Please select role",
    role_description: "Please enter description",
    enter_digit: "Please enter only digits",
    org_name: "Please enter organisation name",
    phone: "Please enter phone number",
    contact_name: "Please enter contact name",
    name: "Please enter name",
    imo_number: "Please enter alphabetic characters and numbers",
    enter_imo_number: "Please enter imo number",
    select_type: "Please select type",
    service_requirement: "Please enter service requirements",
    port_detail: "Please enter port details",
    agent_detail: "Please enter agent details",
    role_id: "Please enter role id",
    select_owner: "Please select owner",
    select_manager: "Please select manager",
    select_office: "Please select office",
    select_fleet: "Please select fleet",
    select_subtype: "Please select subtype",
    country_name: "Please enter country name",
    iso_code: "Please enter ISO code",
    country_name_limit: "Country name should be maximum 50 characters",
    iso_code_length: "ISO code should be exact 2 characters",
    select_country: "Please select country",
    select_port: "Please select port",
    enter_vessel_name: "Please enter vessel name",
    enter_port_name: "Please enter port name",
    country_alpha_spaces:
      "Country name may only contain alphabetic characters and spaces",
    enter_section_name: "Please enter section name",
    enter_subsection_name: "Please enter subsection name",
    enter_service_name: "Please enter service name",
    enter_designation_name: "Please enter designation name",
    enter_riskfactor_name: "Please enter riskfactor name",
    designation_digits: "Designation name only contains exactly 3 digits",
    enter_question_number: "Please enter question number",
    question_number: "Question number only contains maximum 3 digits",
    select_section: "Please select section",
    select_subsection: "Please select subsection",
    select_designation: "Please select designation",
    select_que_number: "Please enter question number",
    enter_question_name: "Please enter question name",
    select_vessel_type: "Please select vessel type",
    select_vessel_subtype: "Please select vessel subtype",
    select_service: "Please select service",
    select_flag: "Please select flag",
    select_active_date: "Please select Active date",
    select_deactive_date: "Please select Deactive date",
    enter_regulation_reference: "Please enter regulation reference message",
    enter_guidance_message: "Please enter guidance message",
    question_number_only: "Question number only contains the numeric values",
    enter_hazard: "Please enter hazard name",
    enter_preventative_barrier: "Please enter preventative barrier name",
    enter_topevent: "Please enter topevent name",
    enter_threat: "Please enter threat name",
    enter_mitigating_barrier: "Please enter mitigating barrier name",
    enter_consequence: "Please enter consequence name",
    enter_escalation_factor: "Please enter escalation factor name",
    enter_escalation_factor_barrier:
      "Please enter escalation factor barrier name",
    select_escalation_barrier: "Please select escalation factor barriers",
    select_mitigating_barrier: "Please select mitigating barriers",
    select_image: "Please upload images",
    enter_work_instructions: "Please enter work instructions",
    enter_project_name: "Please enter project name",
    select_vessel: "Please select vessel",
    select_reviewer: "Please select reviewer",
    select_services: "Please select services",
    select_consultants: "Please select consultants",
    select_date: "Please select date",
    enter_defect: "Please enter defect name",
    enter_description: "Please enter description",
    enter_code: "Please enter code",
    choose_image: "Please choose image",
    select_date_of_birth: "Please select date of birth",
    select_place_of_birth: "Please enter place of birth",
    select_nationality: "Please select nationality",
    enter_street1: "Please enter street1",
    enter_street2: "Please enter street2",
    enter_city: "Please enter city name",
    enter_postal_code: "Please enter postal code",
    enter_rank: "Please enter rank",
    select_date_of_joining: "Please select date of joining",
    enter_work_mobile_number: "Please enter work mobile number",
    enter_home_telephone_number: "Please enter home telephone number",
    enter_home_email_address: "Please enter home email address",
    enter_mobile_number: "Please enter mobile number",
    issuing_authority: "Please enter issuing authority name",
    num: "Please enter number",
    issue_date: "Please enter issue date",
    expiry_date: "Please enter expiry date",
    select_number: "Please select number",
  },
};
